import { css } from '@emotion/css'

import { getThemeColors, mediaQueryHelper, hexToRgba } from '@offerzen/pinata'
import { lineHeight, spacing, borderRadius, breakpoint, fontSize, fontFamily } from '../../lib/styles'
import colors from '../../lib/themes/colors'

const styles = {
  wrapper: css({
    display: 'flex',
    alignItems: 'center',

    '& > * + *': {
      marginLeft: spacing.medium,

      [mediaQueryHelper(breakpoint.phone)]: {
        marginLeft: spacing.default,
      },
    },
  }),

  wrapperError: css({
    marginBottom: '0 !important',
  }),

  errorMessage: css({
    marginBottom: spacing.large,
  }),

  label: css({
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: lineHeight.large,
    color: colors.scorpion,
    userSelect: 'none',
    cursor: 'pointer',
    flex: 1,
  }),

  labelDisabled: css({
    color: colors.grayChateau,
  }),

  checkbox: css({
    position: 'relative',
    boxSizing: 'border-box',
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [mediaQueryHelper(breakpoint.phone)]: {
      width: 20,
      height: 20,
    },
  }),

  input: css({
    cursor: 'pointer',
    appearance: 'none',
    margin: 0,
    width: '100%',
    height: '100%',
    border: `1px solid ${colors.grayChateau}`,
    borderRadius: borderRadius.default,

    '&[disabled]': {
      backgroundColor: colors.catskillWhite,
    },

    '&[disabled]:checked': {
      backgroundColor: colors.catskillWhite,
    },

    '&:checked': {
      background: 'transparent',
    },

    '&:focus': {
      outline: 'none',
    },
  }),

  icon: css({
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
}

export default styles

export const inputTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    borderColor: theme === 'error' ? themed.base : colors.grayChateau,

    '&:checked:not([disabled])': {
      borderColor: themed.base,
      backgroundColor: themed.light,
    },

    '&:checked:hover:not([disabled])': {
      backgroundColor: themed.base,

      '& + * svg': {
        fill: colors.white,
      },
    },

    '&:active': {
      backgroundColor: themed.base,

      '& + * svg': {
        fill: colors.white,
      },
    },

    '&:hover:not([disabled])': {
      borderColor: themed.base,
    },

    '&:focus': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
    },
  })
}

export const iconTheme = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}
